import React from 'react';
import {
    CardActions,
    Datagrid,
    Filter,
    List,
    NumberField,
    SelectField,
    TextField,
    TextInput
} from 'react-admin';
import BcTkHocPhiBtn from "./BcTkHocPhiBtn";

const BillAccountFilter = (props) => (
    <Filter {...props}>
        <TextInput label="ra.action.search" source="q" alwaysOn/>
    </Filter>
);

const PostActions = ({
                         bulkActions,
                         basePath,
                         displayedFilters,
                         filters,
                         filterValues,
                         onUnselectItems,
                         resource,
                         selectedIds,
                         showFilter,

                     }) => (
    <CardActions>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        })}
        {/* Add your custom actions */}
        <BcTkHocPhiBtn/>

    </CardActions>
);

export const BillAccountList = props => (
    <List filters={<BillAccountFilter/>} {...props} actions={<PostActions/>} bulkActionButtons={false}
    perPage={25} exporter={false}>
        <Datagrid>
            <TextField source="id"/>
            <TextField source="customerId"/>
            <TextField source="accountName"/>
            <TextField source="unitName"/>
            <NumberField source="balance" locales="vi-VI" options={{style: 'currency', currency: 'VND'}}/>
            <SelectField source="status" choices={[
                {id: 'ACTIVE', name: 'Hoạt động'},
                {id: 'INACTIVE', name: 'Không hoạt động'},
            ]}/>
        </Datagrid>
    </List>
);

export default BillAccountList
